module.exports = __webpack_public_path__ + "img/chongzhi.71059002.png";